import { Button } from '@/components/ui/button'
import { Info } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

interface BulkInviteSectionProps {
  isGameStarted: boolean
  onUploadClick: () => void
  disabledTooltipText: string
}

export function BulkInviteSection({
  isGameStarted,
  onUploadClick,
  disabledTooltipText,
}: BulkInviteSectionProps) {
  return (
    <div className='flex items-center justify-between pb-3 border-b border-gray-200'>
      <div className='flex flex-col'>
        <span className='text-sm font-medium text-[#0F172A]'>Bulk Invite</span>
        <span className='text-xs text-[#64748B]'>
          Upload a CSV or Excel file to invite multiple students at once
        </span>
      </div>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <Button
                type='button'
                variant='outline'
                onClick={onUploadClick}
                disabled={isGameStarted}
                className={cn(
                  'whitespace-nowrap',
                  isGameStarted
                    ? 'opacity-50 cursor-not-allowed'
                    : 'border-gray-300 hover:bg-gray-50'
                )}
              >
                Upload Roster
              </Button>
            </div>
          </TooltipTrigger>
          {isGameStarted && (
            <TooltipContent className='p-2 max-w-xs text-white bg-gray-800'>
              <div className='flex gap-2 items-center'>
                <Info size={16} />
                <p>{disabledTooltipText}</p>
              </div>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}

